import React, {useCallback, useContext} from "react";
import {StoreLocatorContext} from "../context/store-locator";


const Loading = ()=>{
    const {searching} = useContext(StoreLocatorContext);
    if(searching)
        return <div className={'rz-loading'}></div>
    return null;
}
export default Loading;
